import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService as CoreAuthService } from '@gs-2.0/core';

export const portalAccessGuard: CanActivateFn = () => {
  const authService = inject(CoreAuthService);
  const router = inject(Router);

  if (!authService.hasPortalAccess()) {
    return router.createUrlTree(['/home']);
  }

  return true;
};
